/** https://www.npmjs.com/package/react-form-validator-core for validations */
import { ValidatorForm } from 'react-form-validator-core';
export default ValidatorForm;